import { useState } from "react";
import { Link } from "react-router-dom";
import logo from "url:../assets/logo.png";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  const navItems = [
    { name: "Home", path: "/" },
    { name: "Activities", path: "/activities" },
    { name: "Gallery", path: "/gallery" },
    { name: "News", path: "/news" },
    { name: "About", path: "/about" },
  ];

  return (
    <>
      <nav className="flex justify-between items-center px-4 sm:px-6 md:px-20 py-4 bg-gradient-to-b from-white to-orange-50 backdrop-blur-md shadow-sm sticky top-0 z-50">

        {/* Logo */}
        <div className="flex items-center gap-3">
          <img src={logo} alt="logo" className="w-15 h-15 object-contain contrast-150" />
          <h2 className="text-xl sm:text-2xl font-bold bg-gradient-to-r from-orange-400 via-orange-500 to-amber-500 bg-clip-text text-transparent">
            SGYA
          </h2>
        </div>

        {/* Desktop */}
        <div className="hidden lg:flex gap-10 text-lg font-medium">
          {navItems.map((item, i) => (
            <Link
              key={i}
              to={item.path}
              className="relative group text-gray-700 hover:text-orange-500 transition"
            >
              {item.name}
              <span className="absolute left-0 -bottom-1 h-[2px] w-0 bg-gradient-to-r from-orange-400 to-amber-500 transition-all duration-300 group-hover:w-full"></span>
            </Link>
          ))}
        </div>

        {/* Hamburger */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="flex lg:hidden flex-col justify-center items-center w-10 h-10 rounded-lg hover:bg-orange-100 transition"
        >
          <span
            className={`w-6 h-0.5 bg-gray-800 ${
              menuOpen ? "rotate-45 translate-y-1.5" : ""
            }`}
          ></span>
          <span
            className={`w-6 h-0.5 bg-gray-800 ${
              menuOpen ? "opacity-0" : "my-1"
            }`}
          ></span>
          <span
            className={`w-6 h-0.5 bg-gray-800 ${
              menuOpen ? "-rotate-45 -translate-y-1.5" : ""
            }`}
          ></span>
        </button>
      </nav>

      {/* Mobile */}
      {menuOpen && (
        <>
          <div
            onClick={() => setMenuOpen(false)}
            className="fixed inset-0 bg-black/40 z-40"
          ></div>

          <div className="fixed top-[70px] left-0 w-full bg-white shadow-xl flex flex-col items-center gap-6 py-6 text-lg font-medium z-50">
            {navItems.map((item, i) => (
              <Link
                key={i}
                to={item.path}
                onClick={() => setMenuOpen(false)}
                className="text-gray-700 hover:text-orange-500"
              >
                {item.name}
              </Link>
            ))}
          </div>
        </>
      )}
    </>
  );
}